import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
/** components **/
import { Layout, FadeUp, ParallaxItem } from 'components/organisms';
import { ContentsTitle } from 'components/molecules';
import { SERVICE_NAME, REGISTER_FORM_URL } from '../const';
import { SupporterCommennt, Reports } from 'lib/supporter-voice';

import classNames from 'classnames';
import SwiperCore from 'swiper';
import 'swiper/scss';
import { Swiper, SwiperSlide } from 'swiper/react';

/** styles **/
import s from '../styles/pages/interview.module.scss';
import Pwan from 'assets/images/pwan.png';
import BgLogo from 'assets/images/bg-logo.svg';
import TopHumanImg from 'assets/images/top-human.svg';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';

export const Interview: React.FC = () => {
  const [swiperIsBeginning, setSwiperIsBeginning] = useState<boolean>(true);
  const [swiperIsEnd, setSwiperIsEnd] = useState<boolean>(false);

  const swiperRef = useRef<SwiperCore>();
  const SwiperButtonPrev = (): JSX.Element => {
    return (
      <button onClick={() => swiperRef.current?.slidePrev()} disabled={swiperIsBeginning}>
        <BlackCircleArrow className={classNames(s.navButton, s.prevButton)} />
      </button>
    );
  };

  const SwiperButtonNext = (): JSX.Element => {
    return (
      <button onClick={() => swiperRef.current?.slideNext()} disabled={swiperIsEnd}>
        <BlackCircleArrow className={classNames(s.navButton, s.nextButton)} />
      </button>
    );
  };
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: '/worries',
      });
    }
  }, []);

  return (
    <Layout>
      <div className={s.interviewPageWrapper}>
        <FadeUp delay={0}>
          <ContentsTitle
            className={s.contentsTitle}
            title="REPORT"
            subTitle="サポーターコメント＆インタビュー　レポート"
          />
        </FadeUp>
        <FadeUp delay={0}>
          <div className={s.lead}>
            <ParallaxItem className={s.parallaxBg}>
              <img src={BgLogo} alt={SERVICE_NAME} width={381} height={500} />
            </ParallaxItem>
            <div className={s.inner}>
              <p>
                サポーターの皆さま、ご登録いただき誠にありがとうございます！おかげさまで、2,700名※を超えるサポーター様にご登録をいただきました！11月以降も続々増えております！
                <br />
                <br />
                また数名の方にはインタビューにご協力いただきました。お忙しい中、貴重なお時間をありがとうございました！
                <br />
                <br />
                ご登録時のコメント及びインタビューの中で、応援・共感のメッセージ、
                <br />
                そして参考になる刺激的なご意見をたくさんいただきました。
                <br />
                本当はすべてご紹介したいところではありますが、今回はその中の一部だけ、
                <br />
                いただいたコメントとインタビュー内容をご紹介させていただきます！
              </p>
              <span>※2024年11月1日時点</span>
              <div className={s.notice}>
                <p>サポーターはまだまだ募集中！</p>
                <img src={Pwan} alt="ピーワン" />
              </div>
            </div>
          </div>
          <div className={s.supportersContents}>
            <ContentsTitle className={s.contentsTitle} title="SUPPORTER’S VOICE＆PHOTO" subTitle="サポーターの皆さまの声とペットのお写真" />
            <div className={s.spOnly}>
              <Swiper
                className={s.slideWrapper}
                onBeforeInit={(swiper: SwiperCore) => {
                  swiperRef.current = swiper;
                }}
                onSlideChange={(swiper: SwiperCore) => {
                  setSwiperIsBeginning(swiper.isBeginning);
                  setSwiperIsEnd(swiper.isEnd);
                }}
                spaceBetween={24}
                speed={700}
                slidesPerView={1}
                breakpoints={{
                  1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                  },
                }}
              >
                <SwiperSlide className={s.item}>
                  <div className={s.text}>{SupporterCommennt[0]}</div>
                  <div className={s.text}>{SupporterCommennt[1]}</div>
                  <div className={s.text}>{SupporterCommennt[2]}</div>
                </SwiperSlide>
                <SwiperSlide className={s.item}>
                  <div className={s.text}>{SupporterCommennt[3]}</div>
                  <div className={s.text}>{SupporterCommennt[4]}</div>
                  <div className={s.text}>{SupporterCommennt[5]}</div>
                </SwiperSlide>
                <SwiperSlide className={s.item}>
                  <div className={s.text}>{SupporterCommennt[6]}</div>
                  <div className={s.text}>{SupporterCommennt[7]}</div>
                  <div className={s.text}>{SupporterCommennt[8]}</div>
                </SwiperSlide>
              </Swiper>
              <div className={s.navWrapper}>
                <SwiperButtonPrev />
                <SwiperButtonNext />
              </div>
            </div>
            <ul className={s.pcOnly}>
              {SupporterCommennt.map((comment, index) => (
                <li key={index}>{comment}</li>
              ))}
            </ul>
          </div>
          <div className={s.concierge}>
            <img className={s.topHuman} src={TopHumanImg} alt={SERVICE_NAME} width={219} height={272} />
            <div className={s.text}>
              <p>
                犬さん、猫さん、うさぎさん、鳥さん、エキゾチックアニマルさん
                <br />
                様々なペットオーナーの皆さまからご登録＆コメントをいただきました！
              </p>
              <span>スタッフから心より感謝申し上げます</span>
            </div>
          </div>
          <div className={s.reportContents}>
            <ParallaxItem className={s.parallaxBg}>
              <img src={BgLogo} alt={SERVICE_NAME} width={381} height={500} />
            </ParallaxItem>
            <ContentsTitle
              className={s.contentsTitle}
              title="INTERVIEW REPORT"
              subTitle="サポーターコメント＆インタビュー　レポート"
            />

            <p className={s.introText}>
              サポーターにご登録いただいた方の中から数名の方にインタビューをさせていただきました。
              <br />
              頂いたご意見の一部を簡単ですがご紹介いたします。
            </p>
            <div>
              {Reports.map((report, index) => (
                <div className={s.report} key={index}>
                  <p className={s.q}>{report.q}</p>
                  <p className={s.a}>{report.a}</p>
                  <p className={s.comment}>
                    （スタッフより）
                    <br />
                    {report.comment}
                    <img
                      src={require(`assets/images/${report.image}`)}
                      width={report.imageWidth}
                      alt="INTERVIEW REPORT"
                    />
                  </p>
                </div>
              ))}
            </div>
          </div>
        </FadeUp>
      </div>
      <div className={s.leadContents}>
        <p>
          あなたもサポーターになって、 <br className={s.pcOnly} />
          理想のペット共生型マンションを一緒に実現させませんか？
        </p>
        <a className={s.linkToForm} href={REGISTER_FORM_URL} target="_blank" rel="noreferrer">
          <span className={s.pcOnly}>サポーター登録（無料）</span>
          <span className={s.spOnly}>サポーター登録はこちら</span>
          <GreenCircleArrow className={s.arrowIcon} />
        </a>
      </div>
      <Link className={s.topLink} to="/">
        <BlackCircleArrow className={s.navButton} />トップページへ戻る
      </Link>
    </Layout>
  );
};
